import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HomeService} from '../../services/home.service';
import {Router} from '@angular/router';
import {allLocalStorage, allSessionStorage, PDV_MULTIMARCA, tabHome} from 'src/app/shared/constantes';
import {PermissionService} from 'src/app/shared/services/permission.service';
import {allPermissions} from 'src/app/shared/permissions';
import {Ipdv} from 'src/app/shared/models/pdvResponse';
import {SimyoTemporaryClosureComponent} from '../../../simyo/components/simyo-temporary-closure/simyo-temporary-closure.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DigoService} from 'src/app/services/digo.service';
import {ChatService} from '../../services/chat.service';
import {ChatSoporteService} from '../../services/chat-soporte.service';
import {AuthService} from 'src/app/shared/services/auth.service';
import {FirebaseService} from 'src/app/services/firebase.service';

@Component({
    selector: 'app-hm-header',
    templateUrl: './hm-header.component.html',
    styleUrls: ['./hm-header.component.css', '../../../../assets/css/home-theme.css'],
    standalone: false
})
export class HmHeaderComponent implements OnInit {
    @Input() pdv: Ipdv;
    /** Fuerza el tema oscuro de home (p. ej. página puente /asistent-ia). */
    @Input() forceHomeStyle = false;

    public contractNewBrands: string;
    public contractPepephone: string;
    public brands = {
        republica_movil: 'rm',
        simyo: 'sm',
        amena: 'am',
        orange: 'or',
    };
    public allPermissions = allPermissions;
    public PDV_MULTIMARCA = PDV_MULTIMARCA;
    public FNAC_DISTRIBUTOR: number = environment.production ? 694 : 198;
    public environment = environment;

    get baseUrl(): string {
        return this.auth.getLegacyBaseUrl();
    }

    constructor(
        public router: Router,
        private homeService: HomeService,
        public permSv: PermissionService,
        private modalService: NgbModal,
        private digoService: DigoService,
        private chatService: ChatService,
        private chatSoporteService: ChatSoporteService,
        private auth: AuthService,
        private firebaseService: FirebaseService,
    ) {
        this.contractNewBrands = environment.contractNewBrands;
        this.contractPepephone = environment.contractPepephone;
    }

    ngOnInit(): void {
    }

    /** Tema oscuro de la home (fondo #1f1f1f + logo blanco). */
    get isHomeStyleNavbar(): boolean {
        const url = this.router?.url || '';
        return this.forceHomeStyle || url === '/' || url.includes('/?');
    }

    public hiddenMoreOperations(): boolean {
        if (document.getElementById('credit_phone') || document.getElementById('commissions') || document.getElementById('orders') || document.getElementById('free_terminals')) {
            return false;
        }
        return true;
    }

    public viewBrandRates(brand) {
        this.router.navigate(['/']).then(() => {
            this.homeService.setViewBrandRates(brand);
        });
    }

    public goToCommissions() {
        this.router.navigate(['/']).then(() => {
            this.homeService.setGoToTab(tabHome.COMISIONES);
        });
    }

    public async signOut() {
        this.digoService.sendDataToLogs('log: Logout de usuario - Logout desde botón cabecera -hm-header - signOut');
        try {
            // Un solo remove: ambos endpoints apuntan al mismo almacenamiento FCM en BE.
            const canChat = this.permSv.hasPermFromV2(allPermissions.others.chat);
            const canChatSoporte = this.permSv.hasPermFromV2(allPermissions.others.chat_soporte_pdv);
            if (canChat) {
                await this.chatService.removeFcmToken(this.pdv);
            } else if (canChatSoporte) {
                await this.chatSoporteService.removeFcmToken(this.pdv);
            }
        } finally {
            // Tras avisar al BE: borrar FCM del dispositivo + Auth anónima (evita securetoken al cambiar de usuario)
            await this.firebaseService.clearSessionOnLogout();
            const signinUrl = this.auth.getLegacyBaseUrl() + 'signin.itx?ac=999';
            localStorage.removeItem(allLocalStorage.accessToken);
            sessionStorage.removeItem(allSessionStorage.simyoEarthquakeCoShown);
            window.location.href = signinUrl;
        }
    }

    public checkSimyoTemporaryClosure(path: string) {
        // if (this.permSv.hasPermFromV2(this.allPermissions.simyo.nbss_block)) {
        //     this.openSimyoTemporaryClosure();
        //     return
        // }

        this.router.navigate([path]);
    }

    public openSimyoTemporaryClosure() {
        // this.modalService.open(SimyoTemporaryClosureComponent, {size: 'lg', centered: true, backdrop: 'static'});
    }

}
